import React, { Component } from "react";
import CreateTournamentButton from "../components/CreateTournamentButton";
import moment from "moment-timezone";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import vrsn from "../constants/vrsn";

class CreateTournamentContainer extends Component {
  state = {
    name: "",
    date: moment().tz(
      (this.props.userData || {}).timezone || "Europe/Amsterdam"
    ),
    invalidName: false,
    submitDisabled: false,

    psdDialogOpen: false,
  };

  handleCreate = () => {
    if ((this.props.userData || {}).isPSD) {
      this.setState({ psdDialogOpen: true });
    } else {
      if (!this.state.submitDisabled) {
        this.setState({ submitDisabled: true });
        let tournament = {
          name: this.state.name,
          date: this.state.date
            .tz((this.props.userData || {}).timezone || "Europe/Amsterdam")
            .unix(),
          uid: this.props.user.uid,
          new: true,
          seenOffer: true,
          vrsn: vrsn,
          lang: [languages.getLanguage()],
        };

        if ((this.props.userData || {}).isPSD) {
          tournament["isPSD"] = true;
          tournament["color"] = "#000000";
          tournament["sponsors"] = [
            "https://www.prosoccerdata.com/img/assets/logo.png",
          ];
          tournament["sponsorLinks"] = ["https://www.prosoccerdata.com"];
        }
        if ((this.props.userData || {}).isSporta) {
          tournament["isSporta"] = true;
        }
        if ((this.props.userData || {})["RV"]) {
          tournament["RV"] = true;
        }
        if ((this.props.userData || {})["arenal"]) {
          tournament["arenal"] = true;
        }

        let db = window.firebase.firestore();

        let batch = db.batch();

        let tournamentDoc = db.collection("tournaments").doc();
        let divisionDoc = tournamentDoc.collection("divisions").doc("0");

        batch.set(tournamentDoc, tournament);
        batch.set(divisionDoc, { name: "" });
        batch
          .commit()
          .then((doc) => {
            this.props.history.push("/tournament/" + tournamentDoc.id + "/new");
          })
          .catch((error) => {
            console.log(error.message);
            this.setState({ submitDisabled: false });
          });
      } else {
        this.setState({ invalidName: true });
      }
    }
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.psdDialogOpen}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="xs"
        >
          <DialogTitle id="form-dialog-title">
            {languages.createTournament.createInPsdPlatform}
          </DialogTitle>
          <DialogContent>
            <Typography>
              {languages.createTournament.createInPsdPlatformText}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ psdDialogOpen: false });
              }}
              variant="contained"
              color="primary"
              fullWidth
            >
              {languages.general.close}
            </Button>
          </DialogActions>
        </Dialog>
        <CreateTournamentButton handleCreate={this.handleCreate} />
      </div>
    );
  }
}

export default withRouter(CreateTournamentContainer);
